import { environment } from 'src/environments/environment';

const GUIDEBOOK_BASE_URL = 'https://guidebook.tidy.com';

// Maps the build environment to the path suffix the guidebook host expects.
// Production has no suffix; non-prod builds route to namespaced paths so
// reservation uuids don't collide with prod.
const ENV_PATH_SUFFIX: Record<string, string> = {
  sandbox3: '/sandbox3',
  staging: '/develop',
};

export function getGuidebookEnvSuffix(): string {
  const env = (environment as { environment?: string }).environment ?? '';
  return ENV_PATH_SUFFIX[env] ?? '';
}

export function buildGuidebookUrl(uuid: string): string {
  return `${GUIDEBOOK_BASE_URL}/${uuid}${getGuidebookEnvSuffix()}`;
}
